module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-right-1.e190cad5.png";